import React from 'react';
import { Layout } from 'antd';
import cx from 'classnames';
import { CopyrightOutlined } from '@ant-design/icons';
// @ts-ignore
// import { FormattedMessage } from 'umi';
import styles from './index.less';

const curYear = new Date().getFullYear();

const Footer = ({ className }: { className?: string }) => {
  return (
    <Layout.Footer className={cx(styles.footerContainer, { [className as string]: !!className })}>
      <div>
        Copyright <CopyrightOutlined /> {curYear} Envision Energy | Powered by Smart Web
        Platform
      </div>
    </Layout.Footer>
  );
};

export default Footer;
